import React from "react";
import { useTranslation } from "react-i18next";
import "./styles/layout.css";
import { LanguageSelector } from "./components/LanguageSelector";

export type NavigationTab = "home" | "setup" | "admin" | "approvals" | "requests" | "debug";

interface NavigationProps {
  currentTab: NavigationTab;
  onTabChange: (tab: NavigationTab) => void;
  showSetupWarning?: boolean;
  theme?: string;
  isConfigured?: boolean;
  isAdmin?: boolean;
  isLoading?: boolean;
  hasValidConfiguration?: boolean; // Service Principal existe ET permissions valides
}

export default function Navigation({ currentTab, onTabChange, showSetupWarning = false, theme = "default", isConfigured = false, isAdmin = false, isLoading = false, hasValidConfiguration = false }: NavigationProps) {
  const { t } = useTranslation(["navigation"]);

  // Only show navigation if not loading admin status
  if (isLoading) {
    return null;
  }

  return (
    <nav className={`navigation theme-${theme}`}>
      <div className="nav-container">
        <div className="nav-tabs">
          <button
            className={`nav-tab ${currentTab === "home" ? "active" : ""}`}
            onClick={() => onTabChange("home")}
            disabled={!hasValidConfiguration}
            title={!hasValidConfiguration ? t("navigation:tabs.request") : t("navigation:tabs.request")}
          >
            <span className="nav-icon">🏠</span>
            <span className="nav-label">{t("navigation:tabs.request")}</span>
          </button>

          <button
            className={`nav-tab ${currentTab === "setup" ? "active" : ""} ${showSetupWarning ? "warning" : ""}`}
            onClick={() => onTabChange("setup")}
          >
            <span className="nav-icon">🔧</span>
            <span className="nav-label">{t("navigation:tabs.setup")}</span>
            {showSetupWarning && <span className="nav-badge">!</span>}
          </button>

          {isAdmin && (
            <button
              className={`nav-tab ${currentTab === "admin" ? "active" : ""}`}
              onClick={() => onTabChange("admin")}
              disabled={!hasValidConfiguration}
              title={!hasValidConfiguration ? t("navigation:tabs.admin") : t("navigation:tabs.admin")}
            >
              <span className="nav-icon">⚙️</span>
              <span className="nav-label">{t("navigation:tabs.admin")}</span>
            </button>
          )}

          {isAdmin && (
            <button
              className={`nav-tab ${currentTab === "debug" ? "active" : ""}`}
              onClick={() => onTabChange("debug")}
              disabled={!hasValidConfiguration}
              title={!hasValidConfiguration ? t("navigation:tabs.debug") : t("navigation:tabs.debug")}
            >
              <span className="nav-icon">🔍</span>
              <span className="nav-label">{t("navigation:tabs.debug")}</span>
            </button>
          )}
        </div>
        <div className="nav-settings">
          <LanguageSelector />
        </div>
      </div>
    </nav>
  );
}
